import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, NgForOf} from '@angular/common';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {filter} from 'rxjs';
import {ZnakiService} from '../../services/znaki.service';
import {RazmetkaService} from '../../services/razmetka.service';
import {Meta, Title} from '@angular/platform-browser';
@Component({
    selector: 'pdd-zbaki-home-page',
    templateUrl: './znakihome.component.html',
  imports: [
    NgForOf,
    RouterLink
  ],
    styleUrl: './znakihome.component.less'
})
export class  PDDZnakiHomePageComponent  {
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, public ZnakiService: ZnakiService, public RazmetkaService: RazmetkaService, private title: Title, private meta: Meta) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });
  }

  ngOnInit(): void {
    this.title.setTitle('Знаки и разметка ПДД 2026 — дорожные знаки и дорожная разметка с пояснениями | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'Дорожные знаки и дорожная разметка ПДД 2026 в актуальной редакции. Все группы дорожных знаков, виды разметки, значения, пояснения и требования Правил дорожного движения для подготовки к экзамену и безопасного вождения.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'знаки и разметка ПДД, дорожные знаки, дорожная разметка, ПДД 2026, дорожные знаки ПДД, разметка ПДД, знаки дорожного движения, разметка дорожного движения, значение дорожных знаков, виды дорожной разметки, правила дорожного движения, ПДД РФ, дорожные знаки 2026, дорожная разметка 2026, знаки и разметка правил дорожного движения'
    });
  }
}
